import { render, staticRenderFns } from "./BdrOneCProperties.vue?vue&type=template&id=6146a630&"
import script from "./BdrOneCProperties.vue?vue&type=script&lang=js&"
export * from "./BdrOneCProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports